module.exports = __webpack_public_path__ + "media/images/product/f_o-65b601441a15182073af92d77dc9bfca.png";